<template>
  <div class="row d-flex justify-content-center">
    <div class="col-12">
      <table class="table">
        <tbody>
          <tr class="shadow-sm" v-for="(info, index) in rows" :key="index">
            <td-info-tag
              v-if="showInfoTag(info)"
              :data="info.value"
              :tdLabel="`${info.label}: `"
              :fieldTag="info.fieldTag"
              effect="dark"
            />
            <template v-else-if="info.type === 'contacts'">
              <info-contacts :provider_contacts="infoData.email" :model="infoData" />
            </template>
            <td
              :style="{
                wordBreak: 'auto-phrase',
                textAlign: 'justify',
              }"
              v-else-if="
                typeof info.visibility === 'undefined' ||
                Boolean(info.visibility)
              "
            >
              <h6 class="mb-1">
                <strong>{{ info.label }}:</strong>
              </h6>
              <span v-if="validateIsset(info.value)" class="mt-2">
                {{ info.value }}
              </span>
              <el-tag v-else type="warning" effect="dark" class="mt-2">{{
                $t('common_words.no_assignment')
              }}</el-tag>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>
<script>
import { isset } from 'src/util/Util.js';
import i18n from 'src/i18n';
import InfoContacts from 'src/views/Pages/Dashboard/Supplying/Inventory/Provider/steps/InfoContacts.vue';
import TdInfoTag from 'src/components/Tables/TdInfoTag.vue';

export default {
  name: 'step-confirm',
  components: {
    [InfoContacts.name]: InfoContacts,
    [TdInfoTag.name]: TdInfoTag,
  },
  props: {
    infoData: {
      typeof: Object,
      required: true,
    },
  },
  computed: {
    rows() {
      return [
        {
          label: i18n.t('common_words.names'),
          value: this.infoData.first_name,
        },
        {
          label: i18n.t('common_words.surnames'),
          value: this.infoData.last_name,
        },
        {
          label: i18n.t('common_words.nit'),
          value: this.infoData.nit,
        },
        {
          label: i18n.t('inventory.bank_account'),
          value: this.infoData.bank_account,
        },
        {
          label: i18n.t('inventory.account_type'),
          value: this.infoData.account_type,
        },
        {
          label: i18n.t('inventory.bank_name'),
          value: this.infoData.bank_name,
        },
        {
          label: i18n.t('inventory.articles'),
          value: this.infoData.articles_names,
          fieldTag: 'option',
        },
        {
          label: i18n.t('common_words.companies2'),
          value: this.infoData.businesses_names,
          fieldTag: 'option',
        },
        {
          label: i18n.t('common_words.contacts'),
          value: this.infoData.email,
          type: 'contacts',
        },
      ];
    },
  },
  methods: {
    validateIsset(data) {
      return isset(data);
    },
    showInfoTag(info) {
      return (
        (typeof info.visibility === 'undefined' || Boolean(info.visibility)) &&
        this.validateIsset(info.value) &&
        Array.isArray(info.value) &&
        info.type !== 'contacts'
      );
    },
  },
};
</script>
